<p-dialog
    [modal]="true"
    appendTo="body"
    [(visible)]="viewEmailVisible"
    [maximizable]="true"
    [style]="{width: '80vw', height: '85vh'}"
    (onHide)="selectedViewEmail = null">
    <ng-template pTemplate="header">
        <div class="flex flex-column gap-1">
            <span class="font-semibold text-lg">{{ selectedViewEmail?.subject }}</span>
            <span class="text-sm text-color-secondary">
                To: {{ selectedViewEmail?.recipients?.join(', ') }} &nbsp;|&nbsp; {{ selectedViewEmail?.dateSent | date:'short' }}
            </span>
        </div>
    </ng-template>
    <div class="overflow-y-auto" style="height: calc(100% - 1rem)" [innerHtml]="selectedViewEmail?.body"></div>
</p-dialog>

<p-panel>
    <ng-template pTemplate="header">
        <div>
            <h4>Sent Emails</h4>
        </div>
        <div class="flex flex-auto justify-content-end gap-2" *ngIf="showSend">
            <p-button icon="pi pi-plus" label="New Email" [text]="true"
                (onClick)="newEmailDialogVisible = true; newDraftEmail() "></p-button>
            <p-dialog [(visible)]="newEmailDialogVisible" appendTo="body" #newEmailOp
                [style]="{width: '50vw', height:'75vh'}" styleClass="overflow-y-scroll" (onHide)="cancelEmail()">
                <app-email-composer *ngIf="draftEmail" [emailHandler]="emailHandler" [draftEmail]="draftEmail"
                    (sendEmail)="sendEmail($event)" (cancelEmail)="newEmailDialogVisible = false; cancelEmail();"
                    (draftSaved)="newEmailDialogVisible=false; draftSaved();"></app-email-composer>
            </p-dialog>
        </div>
    </ng-template>
    <div class="flex flex-column overflow-y-scroll">

        <p-table [value]="sortedEmails" [paginator]="sortedEmails.length > 5" sortMode="single" [rows]="5" sortField="dateSent" [sortOrder]="-1">

            <ng-template pTemplate="header">
                <tr>
                    <th></th>
                    <th pSortableColumn="dateSent">Sent Date <p-sortIcon field="dateSent" /></th>
                    <th>Recipients</th>
                    <th>Subject</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-email>
                <tr>
                    <td style="width: 7rem">
                        <span class=" ml-1 mr-1"><i *ngIf="email.deliveryFailed" class="pi pi-exclamation-circle text-red-700" ></i></span>
                        <span class=" ml-1 mr-1"><i *ngIf="email.sent" class="pi pi-send" ></i></span>
                        <span class=" ml-1 mr-1"><i *ngIf="email.received" class="pi pi-inbox"></i></span>
                        <span class=" ml-1 mr-1"><i *ngIf="email.read" class="pi pi-folder-open"></i></span>
                    </td>
                    <td>
                        {{email.dateSent | date: 'short'}}
                    </td>
                    <td>
                        <p-tag *ngFor="let r of email.recipients" icon="pi pi-user" [rounded]="true" [value]="r"/>
                    </td>
                    <td>
                        {{email.subject}}
                    </td>
                    <td>
                        <p-button icon="pi pi-eye" label="View" [text]="true" (onClick)="openViewEmail(email)"></p-button>
                    </td>
                </tr>
            </ng-template>

        </p-table>
    </div>
</p-panel>
